import * as queryString from 'query-string';
import generateActions from './baseAction';
import API from '../api';
import * as actions from '../constants';
import PAGINATE from '../../data/paginate';

const {
  clearErrors,
  filterPayments,
  getPayment,
  receiveGetPayments,
  requestGetPayments,
  showError,
  removePayment,
  updatePayment,
} = generateActions('payment', 'payments');

interface PaymentOptions {
  date?: Date;
  all?: boolean;
  booking_id?: number;
  company_id?: number;
  driver_id?: number;
  order?: string;
  limit?: number;
  page?: number;
  sort?: 'ASC' | 'DESC';
  isArchived?: boolean;
  banking_export_id?: number;
}

const getBankingExports = (page: number = 0) => (dispatch) => {
  dispatch({ type: actions.REQUEST_BANKING_EXPORTS });
  return API.request(
    `/payments/banking-export?page=${page}&limit=${PAGINATE.bankingExports.MAX}`,
  )
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: actions.RECEIVE_BANKING_EXPORTS,
        ...response,
      });
      return response;
    });
};

/**
 * Get the totals for a banking exports
 * @param {Number} id Banking export id
 */
const getBankingExportTotals = (id: number) => (dispatch) => {
  dispatch({ type: actions.REQUEST_BANKING_EXPORT_TOTALS });
  return API.request(`/payments/banking-export/${id}/totals`)
    .then((response) => response.json())
    .then((response) => {
      dispatch({ type: actions.RECEIVE_BANKING_EXPORT_TOTALS });
      return response;
    });
};

const getBankingExport = (id: number) => (dispatch) => {
  dispatch({ type: actions.REQUEST_BANKING_EXPORT });
  return API.request(`/payments/banking-export/${id}`)
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: actions.RECEIVE_BANKING_EXPORT,
        ...response,
      });
      return response;
    });
};

const getPendingAccountsExportCsv = () => (dispatch) => {
  dispatch({ type: actions.REQUEST_PENDING_ACCOUNT_EXPORT });
  return API.request('/payments/pending-accounts/csv')
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: actions.RECEIVE_PENDING_ACCOUNT_EXPORT,
        ...response,
      });
      return response;
    });
};

const getBankingExportCsv = (id: number) => (dispatch) => {
  dispatch({ type: actions.REQUEST_BANKING_EXPORT });
  return API.request(`/payments/banking-export/${id}/csv`)
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: actions.RECEIVE_BANKING_EXPORT,
        ...response,
      });
      return response;
    });
};

/**
 * Fetch a list of notes
 * @param options
 */
const getPayments = (options: PaymentOptions = {}) => (dispatch) => {
  dispatch(requestGetPayments());
  if (!options.page) {
    options.page = 0;
  }
  options.limit = PAGINATE.payments.MAX;
  return API.request(`/payments?${queryString.stringify(options)}`)
    .then((response) => response.json())
    .then((response) => {
      dispatch(receiveGetPayments(response.error, response.data, new Date()));
      return response;
    });
};

/**
 * Fetch a list of payments for a booking
 */
const getBookingPayments = (bookingId: number) => (dispatch) => {
  dispatch(requestGetPayments());
  return API.request(`/payments/booking/${bookingId}`)
    .then((response) => response.json())
    .then((response) => {
      dispatch(receiveGetPayments(response.error, response.data, new Date()));
      return response;
    });
};

const createBankingExport = (): any => (dispatch) => {
  dispatch({ type: actions.REQUEST_BANKING_EXPORT });
  return API.request('/payments/banking-export', 'POST')
    .then((response) => response.json())
    .then((response) => {
      dispatch({
        type: actions.RECEIVE_BANKING_EXPORT,
        ...response,
      });
      return response;
    });
};

export {
  clearErrors,
  createBankingExport,
  filterPayments,
  getBankingExport,
  getBankingExportCsv,
  getPendingAccountsExportCsv,
  getBankingExports,
  getBankingExportTotals,
  getPayment,
  getPayments,
  getBookingPayments,
  showError,
  removePayment,
  updatePayment,
};
